import { memo, PropsWithChildren } from "react";
import "./panel.scss";

interface PanelProps extends PropsWithChildren {
  className?: string;
  role?: string;
  id?: string;
  tabIndex?: number;
  onClick?: () => void;
  noBorder?: boolean;
  hidden?: boolean;
  style?: React.CSSProperties;
  ref?: React.Ref<HTMLDivElement>;
}

const PanelComponent = ({
  role,
  className = "",
  children,
  noBorder,
  hidden,
  ref,
  ...restProps
}: PanelProps) => {
  return (
    <div
      className={`panel-container ${className} ${role === "button" ? "hover" : ""} ${
        noBorder ? "no-border" : ""
      } ${hidden ? "hidden" : ""}`}
      ref={ref}
      {...restProps}
    >
      {children}
    </div>
  );
};

PanelComponent.displayName = "PanelComponent";

export const Panel = memo(PanelComponent);
export { PanelBody } from "./panel-body";
export { PanelFooter } from "./panel-footer";
export {
  PanelHeader,
  PanelActionArea,
  PanelDescription,
  PanelTitle,
  PanelTitleArea,
  PanelSubTitle,
} from "./panel-header";
